module.exports = __webpack_public_path__ + "img/receipt-example_cs.6449f50c.png";